import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { VoyageCheckbox } from '../../voyage-checkbox/src/voyage-checkbox';
import '../../voyage-checkbox/src/voyage-checkbox';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;


 const layerNames: ReadonlyArray<string> = !isVesselOnCloud ? ["Coordinates", "Sailing directions", "Nav areas", "Whale zones (All)", "Whale zones (In force)", "Marpol", "ECA/SECA", "Navtex stations (All)", "Navtex stations (In force)", "Ballast Water Management", "Security zones", "Precautionary Zones"] as const :
["Coordinates", "Sailing directions", "Nav areas", "Whale zones (All)", "Whale zones (In force)", "Marpol", "ECA/SECA" , "Security zones", "Precautionary Zones"] as const

export type LayerName = typeof layerNames[number];

@customElement('vessel-map-layers-selector')
export class VesselMapLayerSelector extends LitElement {
    @property({type: Boolean}) shown: boolean = false;
    
    constructor() {
        super();
    }
    
    static get styles() {
        return [
            css`
            :host {
                display: none;
            }

            :host([shown]) {
                display: flex;
                position: fixed;
                top: 88px;
                right: 175px;
            }

            .container {
                font-family: 'MaerskText';
                font-size: 14px;
                background: var(--neutrals-grey-10);
                border: 1px solid var(--neutrals-grey-7);
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
                border-radius: 3px;
                display: grid;
                grid-template-rows: auto, auto;
                width: 100%;
                padding-top: 10px;
                padding-bottom: 10px;
            }

            voyage-checkbox {
                margin-top: 5px;
                margin-bottom: 5px;
                margin-left: 15px;
                margin-right: 15px;
            }
        `];
    }

    render() {
        return html`
            <div class="container">
                ${(layerNames as string[]).map(name => this.renderCheckbox(name))}
            </div>
        `;
    }

    renderCheckbox(name: LayerName) {
        return html`
            <voyage-checkbox label=${name} id=${name.replace(/ /g, "-")}
                    @input=${(evt:InputEvent) => this.dispatchSelectionEvent(name,(<VoyageCheckbox>evt.target).checked)}>
            </voyage-checkbox>
        `
    }

    dispatchSelectionEvent(name: LayerName, changedValue: boolean) {
        this.dispatchEvent(new CustomEvent('selection-changed', {detail: { layer: name, value: changedValue }}));
    }
};
